import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Checkbox from '../../../../components/checkbox/checkbox';

import styles from './filteritem.module.scss';

class FilterItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      renderChild: false,
      start_count: 0,
      end_count: 100
    };
  }

  componentDidUpdate(prevProps) {
    const { filterCategories } = this.props;
    if (prevProps?.filterCategories?.length && filterCategories?.length === 0) {
      this.handleUpdateState();
    }
  }

  onCheckboxChange = (e, id) => {
    const { handleChange, filter, handleGetSectionList } = this.props;
    handleChange(filter.name, e, id);
    if (handleGetSectionList) handleGetSectionList();
  }

  onCustomFieldCheckboxChange = (e, id, key, fieldKey, cuspTitle) => {
    const { handleChange, filter } = this.props;
    handleChange(filter.name, e, ['level_0', 'level_1', 'level_2', 'level_3'].includes(filter?.permissions?.[0]?.type)
    ? filter?.permissions?.[0]?.type : 'customFields', id, key, fieldKey, cuspTitle);
  };

  handleUpdateState = () => {
    this.setState({ renderChild: true }, () => {
      this.setState({ renderChild: false });
    });
  }

  capitalizeFirstLetter = (text) => {
    if (!text) return text;
    return text.replace(/\b\w/g, char => char.toUpperCase());
  };

  loadMore = () => {
    this.setState(prev => ({ start_count: prev.start_count + 100, end_count: prev.end_count + 100 }));
  }

  render() {
    const {
      filter,
      filterCategories,
      type,
      subCategories,
      opsDashboard, text_field, acr,
      fromNawo,
      capitalize
    } = this.props;
    const bool = true;
    const { renderChild, start_count, end_count } = this.state;
    return (
      <div className={styles.checkList}>
        {subCategories ? (
          <Fragment>
            {filter?.subCategories
              && filter?.subCategories?.map(per => (
                <FormattedMessage
                  key={per.id}
                  id={per.key ? per.key : 'invalid'}
                  defaultMessage={per.title}
                >
                  {txt => (
                    <Checkbox
                      id={`${per.title}`}
                      label={txt}
                      checked={
                        filterCategories?.includes(per.title) ? bool:!bool
                      }
                      onChange={this.onCheckboxChange}
                    />
                  )}
                </FormattedMessage>
              ))}
          </Fragment>
        ) : (
          <Fragment>
            {filter.permissions
              && filter.permissions.slice(start_count, filter?.permissions?.length > 1000 ? end_count : filter?.permissions?.length).map(per => (
                per!==null && (
                <FormattedMessage
                  key={per?.id}
                  id=" "
                  defaultMessage={(opsDashboard || acr)? per?.name : per?.title}
                >
                  {txt => (
                    <Checkbox
                      id={type ? `${per.id}` : (`${per.filterType ? `${per.filterType}-` : ''}${per.title}`)}
                      label={capitalize ? this.capitalizeFirstLetter(txt) : txt}
                      key={renderChild}
                      checked={
                        (() => {
                          if (
                            type === 'asset'
                            && filter.type !== 'dataSourceMultiLevel'
                            && per.type !== 'customFields'
                          ) {
                            if (!filterCategories) return false;
                            const idToCheck = typeof per?.id === 'number' && per?.type !== 'priority' ? JSON.stringify(per?.id) : per?.id;
                            return filterCategories.includes(idToCheck);
                          } if (
                            per.filterType
                            && (!fromNawo || filter.type === 'dataSourceMultiLevel' || per.type === 'customFields')
                          ) {
                            return !!filterCategories.find(
                              cat => cat?.title === (per?.type === 'customFields' ? per?.id : per?.title)
                                && cat?.filterType === per.filterType
                            );
                          }
                            return !!filterCategories.includes(
                              opsDashboard || acr ? per?.name : per?.title
                            );
                        })()
                      }
                      onChange={(e) => {
                        if (per?.type && (per?.type === 'customFields' || ['level_0', 'level_1', 'level_2', 'level_3'].includes(per?.type))) {
                          this.onCustomFieldCheckboxChange(e, text_field ? filter.id : per.id,
                            text_field ? per.title : filter.id, per.key, per.title);
                        } else {
                          this.onCheckboxChange(e, per);
                        }
                      }} />
                  )}
                </FormattedMessage>
              )))}
              {filter?.permissions?.length > 1000 && <button onClick={this.loadMore} className={styles.loadMore_button}>Load More...</button>}
          </Fragment>
        )}
      </div>
    );
  }
}

FilterItem.propTypes = {
  filter: PropTypes.shape({}).isRequired,
  opsDashboard: PropTypes.bool,
  acr: PropTypes.bool
};

FilterItem.defaultProps = {
  opsDashboard: false,
  acr: false
};
export default FilterItem;
